/**
 * getRandom - 返回随机数
 */
/* eslint-disable */

function getRandom(min, max) {
  var minValue = typeof min === 'number' ? min : 0;
  var maxValue = typeof max === 'number' ? max : 1;

  if (maxValue < minValue) {
    var temp = maxValue;
    maxValue = minValue;
    minValue = temp;
  }

  return minValue + Math.random() * (maxValue - minValue);
}

module.exports = {
  name: 'getRandom',
  description: '返回一个随机数，可选 min/max 范围。',
  inputSchema: {
    type: 'object',
    properties: {
      min: {
        type: 'number',
        description: '最小值（默认 0）'
      },
      max: {
        type: 'number',
        description: '最大值（默认 1）'
      }
    },
    required: []
  },
  execute: function(args) {
    var min = args && typeof args.min === 'number' ? args.min : 0;
    var max = args && typeof args.max === 'number' ? args.max : 1;
    var value = getRandom(min, max);

    return Promise.resolve({
      content: [
        {
          type: 'text',
          text: JSON.stringify({
            success: true,
            value: value,
            min: min,
            max: max
          }, null, 2)
        }
      ]
    });
  }
};



// WEBPACK FOOTER //
// ./src/webmcp/tools/getRandom.js